// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/signal.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { CompanySummary } from "./company_summary_pb";
import { file_inventory_v1_company_summary } from "./company_summary_pb";
import type { Documentation } from "./documentation_pb";
import { file_inventory_v1_documentation } from "./documentation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/signal.proto.
 */
export const file_inventory_v1_signal: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_inventory_v1_company_summary, file_inventory_v1_documentation]);

/**
 * Signal is the per-org view of a raw event (CVE, news, sanction, outage,
 * artifact change, etc.). Stateless w.r.t. alert lifecycle — no severity,
 * no work-status, no rule info. The only user input here is `visible` and
 * `is_false_positive`. Alert state lives on Alert (alert.proto).
 *
 * The backend joins the cross-org Signal row with the per-org OrgSignal row
 * before surfacing this proto; the FE doesn't need to distinguish the two.
 *
 * @generated from message inventory.v1.Signal
 */
export type Signal = Message<"inventory.v1.Signal"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string company_id = 2;
   */
  companyId: string;

  /**
   * @generated from field: inventory.v1.SignalType signal_type = 3;
   */
  signalType: SignalType;

  /**
   * @generated from field: optional string title = 4;
   */
  title?: string;

  /**
   * @generated from field: optional string subtitle = 5;
   */
  subtitle?: string;

  /**
   * @generated from field: bool visible = 6;
   */
  visible: boolean;

  /**
   * @generated from field: bool is_false_positive = 7;
   */
  isFalsePositive: boolean;

  /**
   * @generated from field: optional string false_positive_reason = 8;
   */
  falsePositiveReason?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp detection_time = 10;
   */
  detectionTime?: Timestamp;

  /**
   * @generated from field: inventory.v1.CompanySummary company_summary = 11;
   */
  companySummary?: CompanySummary;

  /**
   * known_exploited is true when the signal's CVE is listed in the CISA KEV
   * catalog. Set for vulnerability signals only; drives the "CISA KEV" chip.
   *
   * @generated from field: bool known_exploited = 12;
   */
  knownExploited: boolean;

  /**
   * kev_due_date is the CISA KEV remediation deadline, when the catalog entry
   * has one. Set only when known_exploited; shown in the alert's KEV banner.
   *
   * @generated from field: google.protobuf.Timestamp kev_due_date = 13;
   */
  kevDueDate?: Timestamp;

  /**
   * is_ai_governance marks the AI governance types, shown with the AI icon.
   *
   * @generated from field: bool is_ai_governance = 14;
   */
  isAiGovernance: boolean;

  /**
   * documentation is set only where the caller reads it; ListSignals and ListAlerts leave it unset.
   *
   * @generated from field: optional inventory.v1.Documentation documentation = 15;
   */
  documentation?: Documentation;
};

/**
 * Describes the message inventory.v1.Signal.
 * Use `create(SignalSchema)` to create a new message.
 */
export const SignalSchema: GenMessage<Signal> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal, 0);

/**
 * SignalType enumerates the kinds of signals collected by the platform. The
 * catalog is reduced to 10 user-visible types plus LEGACY_UNCLASSIFIED — the
 * catch-all for the legacy WOW-typed findings carried forward from before
 * the rename. LEGACY_UNCLASSIFIED is never offered to the rule editor.
 * 12-26 and 29 are the risk types the risk classifier assigns. UNCATEGORIZED is
 * its "nothing fits" verdict, unlike UNSPECIFIED, which means not classified.
 *
 * @generated from enum inventory.v1.SignalType
 */
export enum SignalType {
  /**
   * @generated from enum value: SIGNAL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SIGNAL_TYPE_DATA_BREACH = 1;
   */
  DATA_BREACH = 1,

  /**
   * @generated from enum value: SIGNAL_TYPE_WORKFORCE_REDUCTION = 2;
   */
  WORKFORCE_REDUCTION = 2,

  /**
   * @generated from enum value: SIGNAL_TYPE_BANKRUPTCY_FILING = 3;
   */
  BANKRUPTCY_FILING = 3,

  /**
   * @generated from enum value: SIGNAL_TYPE_MATERIAL_LITIGATION_FILING = 4;
   */
  MATERIAL_LITIGATION_FILING = 4,

  /**
   * @generated from enum value: SIGNAL_TYPE_SECURITY_VULNERABILITY_DISCLOSURE = 5;
   */
  SECURITY_VULNERABILITY_DISCLOSURE = 5,

  /**
   * @generated from enum value: SIGNAL_TYPE_PRIVACY_POLICY_UPDATE = 6;
   */
  PRIVACY_POLICY_UPDATE = 6,

  /**
   * @generated from enum value: SIGNAL_TYPE_TERMS_OF_SERVICE_UPDATE = 7;
   */
  TERMS_OF_SERVICE_UPDATE = 7,

  /**
   * @generated from enum value: SIGNAL_TYPE_REGULATORY_SANCTIONS = 8;
   */
  REGULATORY_SANCTIONS = 8,

  /**
   * @generated from enum value: SIGNAL_TYPE_GEOPOLITICAL_WORKFORCE_EXPOSURE = 9;
   */
  GEOPOLITICAL_WORKFORCE_EXPOSURE = 9,

  /**
   * @generated from enum value: SIGNAL_TYPE_SERVICE_OUTAGE_DISCLOSURE = 10;
   */
  SERVICE_OUTAGE_DISCLOSURE = 10,

  /**
   * @generated from enum value: SIGNAL_TYPE_LEGACY_UNCLASSIFIED = 11;
   */
  LEGACY_UNCLASSIFIED = 11,

  /**
   * @generated from enum value: SIGNAL_TYPE_PERMISSIVE_DATA_SHARING = 12;
   */
  PERMISSIVE_DATA_SHARING = 12,

  /**
   * @generated from enum value: SIGNAL_TYPE_AUTONOMOUS_AI_ACTION = 13;
   */
  AUTONOMOUS_AI_ACTION = 13,

  /**
   * @generated from enum value: SIGNAL_TYPE_DATA_USED_FOR_AI_TRAINING = 14;
   */
  DATA_USED_FOR_AI_TRAINING = 14,

  /**
   * @generated from enum value: SIGNAL_TYPE_UNINTENDED_CODE_EXECUTION = 15;
   */
  UNINTENDED_CODE_EXECUTION = 15,

  /**
   * @generated from enum value: SIGNAL_TYPE_INADEQUATE_DATA_RETENTION = 16;
   */
  INADEQUATE_DATA_RETENTION = 16,

  /**
   * @generated from enum value: SIGNAL_TYPE_EXCESSIVE_DATA_COLLECTION = 17;
   */
  EXCESSIVE_DATA_COLLECTION = 17,

  /**
   * @generated from enum value: SIGNAL_TYPE_FOURTH_PARTY_DATA_EXPOSURE = 18;
   */
  FOURTH_PARTY_DATA_EXPOSURE = 18,

  /**
   * @generated from enum value: SIGNAL_TYPE_INSECURE_SECRETS = 19;
   */
  INSECURE_SECRETS = 19,

  /**
   * @generated from enum value: SIGNAL_TYPE_WEAK_ENCRYPTION = 20;
   */
  WEAK_ENCRYPTION = 20,

  /**
   * @generated from enum value: SIGNAL_TYPE_WEAK_AUTHENTICATION = 21;
   */
  WEAK_AUTHENTICATION = 21,

  /**
   * @generated from enum value: SIGNAL_TYPE_UNGOVERNED_INTEGRATIONS_AND_CONNECTORS = 22;
   */
  UNGOVERNED_INTEGRATIONS_AND_CONNECTORS = 22,

  /**
   * @generated from enum value: SIGNAL_TYPE_PRIVACY_VIOLATION = 23;
   */
  PRIVACY_VIOLATION = 23,

  /**
   * @generated from enum value: SIGNAL_TYPE_ACCESS_OR_PERMISSION_DRIFT = 24;
   */
  ACCESS_OR_PERMISSION_DRIFT = 24,

  /**
   * @generated from enum value: SIGNAL_TYPE_EXCESSIVE_PRIVILEGE = 25;
   */
  EXCESSIVE_PRIVILEGE = 25,

  /**
   * @generated from enum value: SIGNAL_TYPE_DISABLED_SECURITY_CONTROLS = 26;
   */
  DISABLED_SECURITY_CONTROLS = 26,

  /**
   * @generated from enum value: SIGNAL_TYPE_UNCATEGORIZED = 27;
   */
  UNCATEGORIZED = 27,

  /**
   * @generated from enum value: SIGNAL_TYPE_NEW_AI_CAPABILITY_DETECTED = 28;
   */
  NEW_AI_CAPABILITY_DETECTED = 28,

  /**
   * @generated from enum value: SIGNAL_TYPE_AI_PROVIDER_DATA_EXPOSURE = 29;
   */
  AI_PROVIDER_DATA_EXPOSURE = 29,
}

/**
 * Describes the enum inventory.v1.SignalType.
 */
export const SignalTypeSchema: GenEnum<SignalType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_signal, 0);

